import { z } from 'zod'
import { allSpPasswordRulesMet, evaluateSpPasswordRules } from './password-rules'

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(1, 'Password is required')
      .superRefine((val, ctx) => {
        const checks = evaluateSpPasswordRules(val)
        if (!allSpPasswordRulesMet(checks)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Password does not meet all requirements',
          })
        }
      }),
    confirmPassword: z.string().min(1, 'Please re-enter your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>

/** Figma 5074-12371 — single Password field; API still receives matching confirm_password. */
export const setInitialPasswordSchema = z.object({
  password: z
    .string()
    .min(1, 'Password is required')
    .superRefine((val, ctx) => {
      const checks = evaluateSpPasswordRules(val)
      if (!allSpPasswordRulesMet(checks)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Password does not meet all requirements',
        })
      }
    }),
})

export type SetInitialPasswordFormData = z.infer<typeof setInitialPasswordSchema>

/** Figma 5074-12371 — editable email before Continue Login → /login. */
export const setPasswordContinueSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid Email'),
})

export type SetPasswordContinueFormData = z.infer<typeof setPasswordContinueSchema>
